import { i18n } from "i18next";
import { getDynamicConfig } from "infrastructure/configuration/configurationHelper";
import LanguageDetector, {
  DetectorOptions,
} from "i18next-browser-languagedetector";
import { loadPortalConfig } from "./modules";

const dynamicConfig = getDynamicConfig();

export const convertCodeShortToLong = (code: string): string => {
  switch (code) {
    case "cs":
      return "cs-CZ";
    case "sk":
      return "sk-SK";
    case "en":
      return "en-US";
    default:
      return "cs-CZ";
  }
};

export const initLanguageDetector = (
  i18n: i18n,
  availableLanguages: string[]
) => {
  const detectorName = "defaultLanguage";
  const languageDetector = new LanguageDetector();

  languageDetector.addDetector({
    lookup: (options) => {
      if (
        dynamicConfig.defaultLanguage &&
        availableLanguages.includes(dynamicConfig.defaultLanguage)
      ) {
        return dynamicConfig.defaultLanguage;
      }

      return "cs";
    },
    name: detectorName,
  });

  const options: DetectorOptions = {
    order: ["querystring", "localStorage", detectorName],
  };

  i18n.use(languageDetector).init({
    detection: options,
  });
};

export const isMultipleLangs = (): boolean => {
  const languages = loadPortalConfig().enabledLanguages;
  return languages?.length > 1;
}